/* eslint-disable react/no-unused-prop-types */
import * as React from 'react';
import { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { toSameApp } from '../utils/checkRoute';

interface AppLinkProps {
  name?: string;
  id?: string;
  children: ReactNode;
  focus?: boolean;
  download?: string;
  style?: Object;
  theme?: 'night' | 'day';
  href: string;
  target?: '_blank' | '_self' | '_parent' | '_top' | 'framename';
  disabled?: boolean;
  forward?: boolean;
  backward?: boolean;
  type?: 'primary' | 'secondary';
  tabIndex?: number;
  displayAs?: 'link' | 'button';
  color?: 'water' | 'blaze' | 'marshmallow' | 'coal';
  ghost?: boolean;
  frosty?: boolean;
  smol?: boolean;
  spa?: boolean;
  history?: any;
  onClick?: Function;
  rel?: string;
  removeContainerSpan?: boolean;
  title?: string;
  arialabel?: string;
  className?: string;
}

export default function AppLink(props: AppLinkProps) {
  return (
    <>
      {toSameApp(props.href) ? (
        <Link
          aria-disabled={props.disabled}
          id={props.id ? props.id : undefined}
          rel={props.rel}
          onMouseDown={(e) => {
            e.preventDefault();
          }}
          style={props.style || {}}
          to={props.href}
          target={props.target}
          className={props.className}
          download={props.download}
          tabIndex={props.tabIndex}
          aria-label={props.arialabel ? props.arialabel : undefined}
          title={props.title ? props.title : undefined}
          key={props.id ? props.id : undefined}
        >
          {props.children}
        </Link>
      ) : (
        <a
          aria-disabled={props.disabled}
          id={props.id ? props.id : undefined}
          rel={props.rel}
          onMouseDown={(e) => {
            e.preventDefault();
          }}
          style={props.style || {}}
          href={props.href}
          target={props.target}
          className={props.className}
          download={props.download}
          tabIndex={props.tabIndex}
          aria-label={props.arialabel ? props.arialabel : undefined}
          title={props.title ? props.title : undefined}
          key={props.id ? props.id : undefined}
        >
          {props.children}
        </a>
      )}
    </>
  );
}
